export default __webpack_public_path__ + "static/media/buyer_benefits_2.dc327768.svg";